import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';
import Panel from '@prisjakt/ui-panel';
import PanelHeader from '@prisjakt/ui-panel-header';
import { bemGenerator } from '@prisjakt/ui-base';
import ForumIcon from 'mdi-react/ForumIcon';
import Button from '@prisjakt/ui-button';
import Topic from './components/forum-topic';

import './index.scss';

const styles = bemGenerator('forum-topic-listing', ['topics', 'forum']);

const ForumTopicListing = ({ topics }) => {
  const { t, market } = useContext(AppContext);

  if (!topics.nodes.length) {
    return null;
  }

  return (
    <Panel header={<PanelHeader title={t('footer', 'forum.title')} />}>
      <div className={styles.block}>
        <div className={styles.topics}>
          {topics.nodes.map(topic => (
            <Topic key={topic.id} topic={topic} />
          ))}
        </div>
        <a
          href={market.forum}
          // eslint-disable-next-line react/jsx-no-target-blank
          target="_blank"
          rel="noopener"
        >
          <div className={styles.forum}>
            <ForumIcon size={60} />
            <Button color="primary">{t('landing', 'forum.go-to')}</Button>
          </div>
        </a>
      </div>
    </Panel>
  );
};

ForumTopicListing.propTypes = {
  topics: PropTypes.shape({
    nodes: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        uri: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        lastPost: PropTypes.string.isRequired,
      })
    ),
  }),
};

ForumTopicListing.defaultProps = {
  topics: {
    nodes: [],
  },
};

export default memo(ForumTopicListing);
